<div class="background-container">
  <div class="background-image"></div>
  <div class="content">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <app-contacts-menu></app-contacts-menu>
  </div>
</div>
